import { useState } from 'preact/hooks';
import { Icon } from '@/components/Icon';
import { recipes } from '@/recipes/_generated';

export function RecipeList() {
  const [query, setQuery] = useState('');
  const [draft, setDraft] = useState('');
  const trimmed = query.trim().toLowerCase();
  const results = trimmed
    ? recipes.filter(({ recipe }) => recipe.title.toLowerCase().includes(trimmed))
    : [];

  return (
    <>
      <div class="search">
        <input
          class="search__input"
          type="text"
          placeholder="Search recipes"
          enterkeyhint="search"
          value={draft}
          onInput={(e) => setDraft(e.currentTarget.value)}
          onBlur={() => setQuery(draft)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') (e.currentTarget as HTMLInputElement).blur();
          }}
        />
        <span class="search__icon">
          <Icon name="search" />
        </span>
      </div>

      {results.length > 0 ? (
        <>
          <div class="results-label">Results</div>
          <ul class="recipe-list">
            {results.map(({ slug, recipe }) => (
              <li key={slug} class="recipe-list__item">
                <a href={`/r/${slug}`}>{recipe.title}</a>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <>
          {trimmed ? <p class="empty">No results found</p> : null}
          <a class="browse-all" href="/browse">
            Browse all {recipes.length} recipes →
          </a>
        </>
      )}
    </>
  );
}
